const count = 5
const dateArray = new Array(count)
var second = 13761871 + parseInt(Math.random() * 100000000)
var first = second + parseInt(Math.random() * 100000)

let date = new Date();
for (var i = 0; i < count; i++) {
    date.setTime(date.getTime() - 24 * 60 * 60 * 1000);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    month = month < 10 ? "" + 0 + month : month
    let day = date.getDate();
    day = day < 10 ? "" + 0 + day : day
    dateArray[count - 1 - i] = year + "-" + month + "-" + day;
}


function randomData(lowerLimit, range) {
    return Number((lowerLimit + Math.random() * range).toFixed(2));
}
function randomIntData(lowerLimit, range) {
    return Number((lowerLimit + Math.random() * range).toFixed(0));
}
function randomDataArray(lowerLimit, range) {
    const resArray = new Array(count)
    for (var i = 0; i < count; i++) {
        resArray[i] = randomData(lowerLimit, range);
    }
    return resArray;
}

export default {

    upLeft: () => ({
        data1: randomDataArray(10, 5),
        data2: randomDataArray(15, 10),
        data3: randomDataArray(25, 10),
        data4: randomDataArray(35, 15),
        date: dateArray
    }),
    left: () => ({
        data1: randomDataArray(10, 15),
        data2: randomDataArray(5, 20),
        date: dateArray
    }),
    upright: () => ({
        data1: randomDataArray(1, 3000),
        data2: randomDataArray(5, 4000),
        date: dateArray
    }),
    right: () => ({
        data1: randomDataArray(3, 10),
        data2: randomDataArray(60, 20),
        data3: randomDataArray(5, 20),
        date: dateArray
    }),
    lowleft: () => ({
        data1: randomData(3, 10),
        data2: randomData(800, 40),
        data3: randomData(400, 600),
        data4: randomData(150, 60),
        data5: randomData(45, 70),
        data6: randomData(215, 50),
        data7: randomData(15, 20),
        data8: randomData(45, 30),
        data9: randomData(135, 80),
        data10: randomData(15, 500),
        date: dateArray
    }),
    getTotalMoney: () => {
        second = first,
            first = second + parseInt(Math.random() * 100000)

        let res = {
            first: first,
            second: second,

        }
        return res;
    },
    queryFreq: () => ({
        province_freq: {
            province_name:["山东","天津","上海","河北","广东","四川"],
            pass_freq:[randomIntData(15, 300),randomData(15, 500),randomData(15, 2000),randomData(15, 2110),randomData(15, 4000),randomData(15, 400)],
            coord:["116.99347,36.684977","117.212395,39.094565","121.470766,31.233459","114.506006,38.050585","113.269704,23.138526","104.072906,30.660793"],
            pass_amount:[randomData(15, 300),randomData(15, 500),randomData(15, 200),randomData(15, 211),randomData(15, 400),randomData(15, 300)],
        },
        station_freq: {
            ex_name:["北京站","济南站","平原站","西宁站","海口站","哈尔滨站"],
            pass_freq:[randomIntData(15, 30),randomData(15, 50),randomData(15, 200),randomData(15, 20),randomData(15, 40),randomData(15, 30)],
            coord:["116.433608,39.911127","116.997267,36.677446","116.446461,37.176174","101.821712,36.626258","110.167956,20.033617","110.167956,20.033617"],
            pass_amount:[randomData(15, 30),randomData(15, 5),randomData(15, 2),randomData(15, 21),randomData(15, 4),randomData(10, 10)],

        },
    }),
    getAppNum: () => ({
        E: {
            app_add:randomIntData(1000, 2000),
            app_all:200*10000
        },
        M: {
            app_add:randomIntData(800, 2000),
            app_all:300*10000,
            app_live:randomIntData(10000, 10000)

        },
    }),


}


// WEBPACK FOOTER //
// ./src/mock/dashboard.js